import React from "react";
import { createPortal } from "react-dom";
import { getJobHistoryEntries } from "../utils/jobHistoryUtils";

// Reusable "History" popup: shows every note and supervisor note ever added
// to `job`, plus any job connected to it (Continue jobs, Extend From
// Existing WO Stem jobs), as one running record. Drop this into any page's
// Job Details popup alongside a "History" button — pass the currently
// selected job and that page's full jobs list, and it renders identically
// everywhere.
const JobHistoryPopup = ({ job, jobs = [], onClose }) => {
  if (!job) return null;

  const entries = getJobHistoryEntries(job, jobs);

  return createPortal(
    <>
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.55)",
          zIndex: 1999998,
        }}
      ></div>

      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          margin: 0,
          width: "min(700px, calc(100vw - 40px))",
          maxHeight: "85vh",
          overflowY: "auto",
          background: "#fff",
          padding: 20,
          borderRadius: 8,
          boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
          textAlign: "left",
          boxSizing: "border-box",
          zIndex: 1999999,
        }}
      >
        <h2 style={{ marginTop: 0 }}>Job History</h2>
        <p style={{ marginTop: -8, color: "#64748b", fontSize: 13 }}>
          All notes and supervisor notes for WO {job.wo || job.id}
          {job.wo ? ", and any jobs connected to it (Continue / Extend From Existing WO Stem)." : "."}
        </p>

        {entries.length === 0 && (
          <p style={{ fontStyle: "italic" }}>No notes have been added yet.</p>
        )}

        <div style={{ display: "grid", gap: 12 }}>
          {entries.map((entry, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                padding: 12,
                background: entry.type === "Supervisor Note" ? "#f5f3ff" : "#f8fafc",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 6,
                  fontSize: 12,
                  color: "#475569",
                  marginBottom: 6,
                  fontWeight: 700,
                }}
              >
                <span>{entry.type}</span>
                <span>
                  WO {entry.wo}
                  {entry.occurrenceDate ? ` • ${entry.occurrenceDate}` : ""}
                </span>
              </div>

              <div style={{ whiteSpace: "pre-wrap" }}>{entry.text}</div>

              <div style={{ marginTop: 6, fontSize: 12, color: "#64748b" }}>
                {entry.author}
                {entry.authorRole ? ` (${entry.authorRole})` : ""}
                {entry.date ? ` — ${new Date(entry.date).toLocaleString()}` : ""}
              </div>

              {Array.isArray(entry.files) && entry.files.length > 0 && (
                <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 10 }}>
                  {entry.files.map((file, fileIndex) => (
                    <a
                      key={fileIndex}
                      href={file.fileURL}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ fontSize: 12 }}
                    >
                      {file.fileName || "File"}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="modal-buttons">
          <button className="red-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </>,
    document.body
  );
};

export default JobHistoryPopup;
